import { createFormModifierGroups, createFormSubItemGroups } from '.';

export const createFormGroupsFromMenuItem = (item: IMenuItem) => {
  const { defaultModifiers, modifiers, subItems } = item;
  const formModifierGroups = createFormModifierGroups(modifiers, defaultModifiers);
  const formSubItemGroups = createFormSubItemGroups(subItems);

  return [...formModifierGroups, ...formSubItemGroups];
};
